import { StyleSheet } from 'react-native';

export const AGENT_MENTION_ROW_HEIGHT = 44;
export const AGENT_MENTION_MAX_VISIBLE_ROWS = 4.5;

/**
 * Android ScrollView collapses to ~0 when its parent only has maxHeight.
 * Pin an explicit height so the picker is a real list, not a hairline.
 */
export function getAgentMentionListHeight(count) {
  const n = Math.max(0, Number(count) || 0);
  if (n === 0) return AGENT_MENTION_ROW_HEIGHT;
  const separators = Math.max(0, n - 1) * StyleSheet.hairlineWidth;
  return Math.min(
    n * AGENT_MENTION_ROW_HEIGHT + separators,
    AGENT_MENTION_ROW_HEIGHT * AGENT_MENTION_MAX_VISIBLE_ROWS,
  );
}
